import { render } from "./AddDashboard.vue?vue&type=template&id=4b4702f1"
import script from "./AddDashboard.vue?vue&type=script&lang=js"
export * from "./AddDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__